import apiClient from '../../../lib/axios';

export const fetchDocumentTypeFields = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/document-type-fields?${params.toString()}`);
  return data;
};

export const fetchActiveDocumentTypeFields = async () => {
  const { data } = await apiClient.get('/api/document-type-fields/active');
  return data;
};

export const fetchDocumentTypeFieldById = async (id) => {
  const { data } = await apiClient.get(`/api/document-type-fields/${id}`);
  return data;
};

export const createDocumentTypeField = async (payload) => {
  const { data } = await apiClient.post('/api/document-type-fields', payload);
  return data;
};

export const updateDocumentTypeField = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/document-type-fields/${id}`, payload);
  return data;
};

export const deleteDocumentTypeField = async (id) => {
  const { data } = await apiClient.delete(`/api/document-type-fields/${id}`);
  return data;
};

export default fetchDocumentTypeFields;
